import {} from "../Observable/mod.js";
import { strictEqual } from "../utils/mod.js";
import { BasicReference } from "./BasicReference.js";
/**
 * A reference that maps the value of another reference
 *
 * @remarks
 *
 * Retains a strong reference to the origin.
 *
 * @internal scope: workspace
 */
export class ReferenceMapped extends BasicReference {
    /**
     * @remarks
     *
     * Serves a dual purpose:
     * 1. It holds the options used to create the reference.
     * 2. It retains a strong reference to the origin,
     *   preventing it from being garbage collected while this reference exists.
     *
     * @internal scope: package
     */
    #options;
    /**
     * @internal scope: package
     */
    #originSubscription;
    constructor(options) {
        const { comparator, origin, onUpdate, transform } = options;
        const initialValue = transform(origin.value);
        super({ initialValue, onUpdate, comparator });
        this.#options = options;
        // Subscribe to the origin as soon as the instance is created
        this.#originSubscription = origin.subscribe(this.#originObserver);
    }
    /**
     * @internal scope: package
     */
    #originObserver = {
        next: (value) => {
            const options = this.#options;
            const { comparator, transform } = options;
            const previousValue = this.get();
            const nextValue = transform.call(null, value);
            const isEqual = comparator ?? strictEqual;
            if (!isEqual(previousValue, nextValue)) {
                this.set(nextValue);
            }
        },
    };
    subscription = {
        subscriber: this.#originObserver,
        unsubscribe: () => {
            this.#originSubscription.unsubscribe();
        },
    };
}
